import React from "react";
import SceneContainer from "./SceneContainer";
import SceneDefault from "./SceneDefault";
import SceneDynamic from "./SceneDefault";
import SceneLevelsList from "./SceneLevelsList";
import SceneZoomButton from "./SceneZoomButton";

const Scene = props => {
  const {
    getStepConfiguration,
    defaultLevels,
    dinamycLevels,
    sceneSetting,
    getSceneImages,
    onZoom,
    getItemByAlias
  } = props;

  return (
    <SceneContainer>
      <SceneDefault>
        <SceneLevelsList
          getItemByAlias={(alias) => getItemByAlias(alias)}
          getStepConfiguration={alias => getStepConfiguration(alias)}
          type="default"
          config={sceneSetting}
          getSceneImages={alias => getSceneImages(alias)}
          items={defaultLevels}
        />
      </SceneDefault>
      <SceneDynamic>
        <SceneLevelsList
          getItemByAlias={(alias) => getItemByAlias(alias)}
          getStepConfiguration={alias => getStepConfiguration(alias)}
          type="dynamic"
          getSceneImages={alias => getSceneImages(alias)}
          items={dinamycLevels}
          config={sceneSetting}
        />
      </SceneDynamic>
      <SceneZoomButton onZoom={type => onZoom(type)} />
    </SceneContainer>
  );
};

export default Scene;
